/**
 * UI Constants
 * Configuration values for UI behavior and interactions
 */

// Button cooldown durations (in milliseconds)
export const BUTTON_COOLDOWN_DURATION = 300;

// The single mobile/desktop chrome boundary (responsive spec 2026-08-10): at
// or above it, desktop chrome (AppHeader + sidebar); below it, mobile chrome
// (MobileHeader + bottom-sheet nav / force-collapsed sidebar). Shared by
// `app-shell.tsx` (which chrome to render) and `useSidebarCollapse` (when to
// force-collapse) — they must agree on the same width or the shell becomes
// incoherent, so this is the single source of truth for it. Both query
// strings derive from the same pixel value so the two sides of the boundary
// can never drift apart.
const DESKTOP_MIN_WIDTH_PX = 1024;
export const DESKTOP_BREAKPOINT_QUERY = `(min-width: ${DESKTOP_MIN_WIDTH_PX}px)`;
// The complement of DESKTOP_BREAKPOINT_QUERY, for behavior that exists only
// below the boundary (data-table card mode, the list pages' filter bottom
// sheet). Matching Tailwind's `max-lg:` exactly.
export const BELOW_DESKTOP_QUERY = `(max-width: ${DESKTOP_MIN_WIDTH_PX - 1}px)`;

// The phone-only tier (Unit 4 assets spec §1.11): reserved for presentations
// justified by physically small screens — the fullscreen asset viewer and the
// two-column asset grid — NOT a third layout tier. Everything that re-arranges
// layout keeps gating on the lg boundary above; anything hover-dependent gates
// on pointer capability instead (spec §2.5). Matches Tailwind's `max-sm:`.
const SM_MIN_WIDTH_PX = 640;
export const PHONE_ONLY_QUERY = `(max-width: ${SM_MIN_WIDTH_PX - 1}px)`;

// The public gallery's phone boundary (DV-3717): its design re-arranges at
// Tailwind's `md`, unlike the app, which re-arranges only at lg (above). Not a
// shared third tier; exported for the gallery, whose phone-only behaviour CSS
// cannot switch and whose image `sizes` name the same width. Matches `max-md:`.
export const MD_MIN_WIDTH_PX = 768;
export const BELOW_MD_QUERY = `(max-width: ${MD_MIN_WIDTH_PX - 1}px)`;
